{
    "customers_title": "Customers",
    "customers_description": "The single customer master. Every complaint, call, branch visit and survey response resolves to a record here.",
    "customer": "Customer",
    "segment": "Segment",
    "status": "Status",
    "identity": "Identity",
    "phone": "Phone",
    "branch": "Branch",
    "activity": "Last activity",
    "vip": "VIP customer",
    "requires_assistance": "Requires assistance",
    "search_placeholder": "Name, reference, phone, civil ID…",
    "open_complaints_one": "{{count}} open complaint",
    "open_complaints_other": "{{count}} open complaints",
    "segments": {
        "micro": "Micro",
        "sme": "SME",
        "corporate": "Corporate",
        "retail": "Retail"
    },
    "tabs": {
        "overview": "Overview",
        "timeline": "Timeline",
        "products": "Products",
        "relationships": "Relationships",
        "consents": "Consent",
        "duplicates": "Possible duplicates"
    },
    "overview": {
        "identity": "Identity & contact",
        "preferences": "Preferences",
        "flags": "Flags & risk",
        "rollups": "Activity",
        "no_products": "No products or facilities recorded.",
        "no_relationships": "No relationships recorded.",
        "no_consents": "No consent records.",
        "masked_hint": "Sensitive values are masked. Revealing one is recorded in the audit trail."
    },
    "timeline": {
        "title": "Interaction timeline",
        "description": "Every interaction across every channel, in one chronological stream.",
        "empty": "No interactions recorded yet.",
        "all": "All",
        "add_note": "Add note",
        "note_placeholder": "Record a note against this customer…",
        "internal_only": "Internal only",
        "duration": "Duration",
        "outcome": "Outcome"
    },
    "products": {
        "reference": "Reference",
        "stage": "Stage",
        "approved": "Approved",
        "outstanding": "Outstanding",
        "arrears": "In arrears",
        "disbursed_on": "Disbursed"
    },
    "relationships": {
        "financial": "Financial exposure",
        "ownership": "{{percent}}% ownership"
    },
    "kyc": "KYC",
    "preferred_channel": "Preferred channel",
    "preferred_language": "Language",
    "relationship_manager": "Relationship manager",
    "risk_rating": "Risk rating",
    "unidentified_banner": "This contact has not been identified yet. Confirm who they are to attribute their history.",
    "merged_banner": "This record was merged into another. You are viewing the surviving record.",
    "duplicates": {
        "title": "Possible duplicates",
        "description": "Records sharing an identity document or contact point. Nothing is merged automatically — review each pair.",
        "confidence": "Confidence",
        "merge": "Merge…",
        "empty": "No probable duplicates found."
    },
    "events": {
        "title": "Spine event explorer",
        "description": "Domain events flowing between modules, what handled each one, and whether anything failed.",
        "replay": "Replay",
        "replayed": "Replayed",
        "listeners": "Listeners",
        "failed": "Failed",
        "payload": "Payload",
        "correlated": "Same originating action",
        "no_listeners": "No listeners subscribed — recorded for traceability.",
        "empty": "No events recorded yet."
    },
    "compliance": {
        "title": "RFP compliance matrix",
        "description": "Requirement coverage, derived from @rfp annotations in the codebase rather than declared by hand.",
        "show_me": "Show me",
        "mandatory": "Mandatory",
        "essential": "Essential",
        "desirable": "Desirable",
        "implemented": "Implemented",
        "planned": "Planned",
        "milestone": "Milestone",
        "outstanding_only": "Outstanding only",
        "all_requirements": "All requirements",
        "export": "Export as CSV"
    },
    "consents": {
        "description": "Consent is held per purpose and per channel. Agreeing to service messages by SMS is not agreeing to marketing by WhatsApp.",
        "caption": "Consent by purpose and channel",
        "purpose": "Purpose",
        "saved": "Consent updated.",
        "audit_note": "Every change is recorded in the audit trail with who made it and when. Withdrawals are kept, not deleted.",
        "purposes": {
            "service": "Service messages",
            "marketing": "Marketing",
            "surveys": "Surveys",
            "data_sharing": "Data sharing",
            "recording": "Call recording"
        },
        "state": {
            "granted": "Consent given",
            "withdrawn": "Consent withdrawn",
            "unknown": "Not recorded"
        }
    },
    "segments_page": {
        "title": "Segments",
        "description": "Rule-based groups of customers, evaluated live rather than stored.",
        "empty_title": "No segments defined",
        "empty_description": "A segment is a saved question about the customer book — it is answered fresh each time it is opened.",
        "built_in": "Built in",
        "inactive": "Inactive",
        "remove": "Remove segment",
        "removed": "Segment removed.",
        "match_all": "All conditions must hold",
        "match_any": "Any condition may hold",
        "view_members": "View members",
        "vocabulary_title": "What a segment can ask about",
        "vocabulary_note": "Segments are limited to these fields. The list comes from the evaluator itself, so a segment can never be written against something it has no way to query."
    },
    "import": {
        "title": "Import customers",
        "description": "Load customer records from a CSV file. Check the file first — an import is all or nothing.",
        "file_title": "The file",
        "file_label": "CSV file",
        "check": "Check the file",
        "commit": "Import",
        "columns": "Recognised columns. Required ones are marked. At most {{max}} rows per file.",
        "ready": "{{count}} of {{total}} rows are ready to import.",
        "rejected": "{{count}} rows have problems. Nothing will be imported until they are fixed.",
        "imported": "Imported {{count}} customer records.",
        "missing_columns": "The file is missing required columns: {{columns}}.",
        "errors_title": "Problems found",
        "line": "Line {{line}}",
        "duplicates_title": "Possible duplicates",
        "duplicates_note": "These rows look like customers already on the master. They are skipped rather than creating a second copy.",
        "duplicate_of": "Line {{line}} matches {{reference}} ({{percent}}% confidence)"
    }
}
